import { memo, ReactNode, useEffect } from "react";
import { updateLocalization } from "./i18n";

export interface LocalizationSettings {
  enabled?: boolean | null;
}

export const LocalizationProvider = memo(function LocalizationProvider({
  localization,
  children,
}: {
  localization: LocalizationSettings | undefined;
  children: ReactNode;
}) {
  useEffect(() => {
    updateLocalization(localization?.enabled ?? false);
  }, [localization?.enabled]);

  return <>{children}</>;
});
